(() => {
 const init = () => document.querySelectorAll('section[id^="MainProduct-"]').forEach(root => {
  if (root.dataset.rePurchaseReady) return; root.dataset.rePurchaseReady='true';
  const update = () => {
   root.querySelectorAll('variant-selects input[type="radio"]').forEach(el=>el.setAttribute('aria-label',el.value));
   root.querySelectorAll('product-info-upsell').forEach(el=>{const button=el.querySelector('.upsell__toggle-switch');if(button){button.setAttribute('aria-label',(el.dataset.selected==='true'?'Entfernen: ':'Hinzufügen: ')+(el.querySelector('h3')?.textContent.trim()||'Zusatzprodukt'));button.setAttribute('aria-pressed',el.dataset.selected==='true'?'true':'false');}});
   const qty = Number(root.querySelector('quantity-breaks input[name="quantity"]:checked')?.value || 1);
   const extras = !!root.querySelector('product-info-upsell[data-selected="true"]');
   const complex = qty > 1 || extras;
   root.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(el => {el.style.display=complex?'none':'';});
   const note=root.querySelector('.re-checkout-note'); if(note) note.hidden=!complex;
  };
  root.addEventListener('change',update);root.addEventListener('click',()=>requestAnimationFrame(update));
  new MutationObserver(update).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-selected','checked']});
  update();
 });
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
 document.addEventListener('shopify:section:load',init);
})();